/*
 * Copyright (c) Nexign, JSC, 2021-2022.
 */
/**
 * Page Subscriber mobile styled
 *
 * @author Yakov Gushchin
 * @version 1.17.0
 * @since 1.12.0
 */

import styled from 'styled-components';

import { fonts } from '../../../../theme';

export const SubscriberMobileModeStyled = styled.div.attrs({
    className: 'subscriber-mobile__mode-title',
})`
    ${fonts.textMainBold};
    margin-bottom: 12px;
`;

export const SubscriberMobileTableStatusStyled = styled.div.attrs({
    className: 'subscriber-mobile__table-status',
})`
    .subscriber-mobile__table-status-info {
        width: 100%;
        padding-left: 32px;
        padding-right: 32px;
    }
`;
